//export const EMPLOYEE_API_BASE_URL = "http://ec2-13-203-198-224.ap-south-1.compute.amazonaws.com:8080"; 
export const EMPLOYEE_API_BASE_URL ="https://backend.rajasreetownships.in";
// export const EMPLOYEE_API_BASE_URL ="http://localhost:8080";